<script setup lang="ts">
import type { JSX } from '@ionic/core'

const modelValue = defineModel<string | number | boolean>()
const props = withDefaults(defineProps<JSX.IonSelect & {
	isRequired?: boolean
}>(),
{
	interface: 'action-sheet',
	errorText: undefined,
	cancelText: 'abbrechen',
})

const actionSheetOptions = computed(() => {
	return {
		...props.interfaceOptions,
		header: 'Bitte auswählen:',
		cssClass: 'select-action-sheet',
	}
})

const computedLabel = computed(() => {
	if (props.disabled) return undefined
	return props.label + (props.isRequired ? '*' : '')
})
</script>

<template>
	<ion-select
		v-model="modelValue"
		v-bind.attr="$attrs"
		v-bind.prop="props"
		:interface-options="actionSheetOptions"
		:class="{ 'ion-invalid': !!errorText, 'ion-touched': !!errorText }"
		:error-text="errorText"
		:label="computedLabel"
	>
		<slot />
	</ion-select>
</template>

<style lang="scss">
/* Der Actionsheet öffnet sich außerhalb des Doms von der Komponente, deswegen greift kein scoped css*/
.select-action-sheet {
	--background: #fff !important;
	--color: #000 !important;
	--button-color: #000 !important;
	--button-background-focused: #fff !important;
	--button-color-selected: var(--ion-color-primary-contrast) !important;

	.action-sheet-button,
	.action-sheet-title {
		font-size: 14px;
		font-weight: 400;
		&.action-sheet-selected {
			font-weight: 700;
			border-top: 2px solid var(--ion-color-primary-contrast);
			border-bottom: 2px solid var(--ion-color-primary-contrast);
		}
	}

	.action-sheet-title {
		padding-top: 30px;
	}

	.action-sheet-button {
		padding: 10px;
		min-height: 37px;
	}

	button.action-sheet-selected {
		--button-background: var(--ion-color-primary);
	}

	.action-sheet-group-cancel {
		// Schwarzer Hintergrund mit primary Schrift
		--button-background: var(--ion-color-primary-contrast);
		--button-background-selected: var(--ion-color-primary-contrast);
		--button-color: var(--ion-color-primary);
		--button-color-selected: var(--ion-color-primary);

		// auf Klick dann invertiert
		--button-background-activated: var(--ion-color-primary);
		--button-background-activated-opacity: 1;
		--button-background-focused: var(--ion-color-primary);
		--button-background-focused-opacity: 1;
		--button-background-hover: var(--ion-color-primary);
		--button-background-hover-opacity: 1;
		--button-color-activated: var(--ion-color-primary-contrast);
		--button-color-focused: var(--ion-color-primary-contrast);
		--button-color-hover: var(--ion-color-primary-contrast);

		.action-sheet-button {
			min-height: 48px;
			font-weight: 700;
		}
	}
}

.select-action-sheet.ios {
	.action-sheet-button {
		.action-sheet-button-inner {
			text-align:  center;
		}
	}
}

.select-action-sheet.md {
	.action-sheet-button {
		.action-sheet-button-inner {
			justify-content:  center;
		}
	}
}
</style>
